import CategoryItem from "./CategoryItem";
import { useGetHeaderMenuItems } from "../ServertSideStates";
import {  useState } from "react";

const CategoryIndex = () => {
  const menuItems = useGetHeaderMenuItems();
  console.log("menuitemsss",menuItems)
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [activeItemIndex, setActiveItemIndex] = useState<number | null>(0); 
  const handleHover = (index: number | null) => {
    
    setHoveredIndex(index);
  };
  const handleMouseLeave = () => {
    setActiveItemIndex(0);
  };
 
  return (
    <>
      <div className="!flex gap-6 items-center !h-full"
      onMouseLeave={handleMouseLeave}
      >
        {menuItems?.data?.data
          ? menuItems.data.data.map((item: any, index: number) => {
              return (
                <>
                  <CategoryItem
                    key={index}
                    activeItemIndex={activeItemIndex}
                    setActiveItemIndex={setActiveItemIndex}
                    item={item}
                    isHovered={hoveredIndex === index}
                    onHover={() => handleHover(index)}
                    onMouseLeave={() => handleHover(null)}
                  />
                </>
              );
            })
          : []}
      </div>
    </>
  );
};

export default CategoryIndex;
